"use client";

import React from "react";
import Link from "next/link";
import { useIsAdLanding } from "@/lib/hooks/useIsAdLanding";
import type { ButtonConfig } from "@/components/ui/HeroSection";
import type { TrackingId } from "@/lib/tracking";
import { Button } from "@/components/ui/Button";
import { NewButton } from "@/components/ui/NewButton";

function getAdLandingButtons(): ButtonConfig[] {
  return [
    {
      text: "Book a Demo",
      href: "/book-a-demo",
      variant: "primary",
      target: "_self",
      arrow: "grow",
      size: "lg",
    },
  ];
}

export function HeroButtons({
  buttons,
  buttonTrackingId,
  extraButtons,
  className,
}: {
  buttons: ButtonConfig[];
  buttonTrackingId?: {
    primaryId?: TrackingId;
    secondaryId?: TrackingId;
  };
  extraButtons?: React.ReactNode;
  className: string;
}) {
  const isAdLanding = useIsAdLanding();
  const finalButtons = isAdLanding ? getAdLandingButtons() : buttons;

  return (
    <div className={className}>
      {finalButtons &&
        (() => {
          const isSingleButton = finalButtons.length === 1;

          return finalButtons.map((button, index) => {
          const trackingId =
            isAdLanding
              ? "hero-book-a-demo-utm"
              : isSingleButton || index === 0
                ? buttonTrackingId?.primaryId || "hero-book-a-demo"
                : buttonTrackingId?.secondaryId || "hero-start-free-trial";

            if (button.href) {
              return (
                <Link
                  key={`${button.href}-${index}`}
                  href={button.href}
                  target={button.target || "_blank"}
                  rel={button.target === "_self" ? undefined : "noopener noreferrer"}
                  data-mixpanel-id={trackingId}
                >
                  {button.arrow ? (
                    <NewButton
                      variant={button.variant}
                      size={button.size || "lg"}
                      arrow={button.arrow}
                      disclaimer={button.disclaimer}
                      className={button.className}
                    >
                      {button.text}
                    </NewButton>
                  ) : (
                    <Button variant={button.variant} size={button.size || "lg"} asChild>
                      {button.text}
                    </Button>
                  )}
                </Link>
              );
            }

            return (
              <Link key={`calendly-${index}`} href={"/book-a-demo"} target="_self" data-mixpanel-id={trackingId}>
                {button.arrow ? (
                  <NewButton
                    variant={button.variant}
                    size={button.size || "lg"}
                    arrow={button.arrow}
                    disclaimer={button.disclaimer}
                    className={button.className}
                  >
                    {button.text}
                  </NewButton>
                ) : (
                  <Button variant={button.variant} size={button.size || "lg"} asChild>
                    {button.text}
                  </Button>
                )}
              </Link>
            );
          });
        })()}


      {/* Only show extraButtons for non-ad sessions */}
      {!isAdLanding ? extraButtons : null}
    </div>
  );
}

